export class AppMenu {
    nome: string;
    path: string;
    img: string;
    constructor(message: string,path:string,img:string) {
        this.nome = message;
        this.path = path;
        this.img = img;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/AppMenu.ts